export const ColorIcon = ({ primary, secondary }: { primary: string; secondary: string }) => {
    return (
        <svg width='48' height='28' viewBox='0 0 48 28' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_1133_15040)'>
                <rect width='28' height='28' rx='14' fill={primary} />
                <rect x='0.5' y='0.5' width='27' height='27' rx='13.5' stroke='black' strokeOpacity='0.1' />
                <rect x='20' width='28' height='28' rx='14' fill={secondary} />
                <rect x='20.5' y='0.5' width='27' height='27' rx='13.5' stroke='black' strokeOpacity='0.1' />
            </g>
            <defs>
                <clipPath id='clip0_1133_15040'>
                    <path
                        d='M0 2C0 0.895431 0.895431 0 2 0H46C47.1046 0 48 0.895431 48 2V26C48 27.1046 47.1046 28 46 28H2C0.895431 28 0 27.1046 0 26V2Z'
                        fill='white'
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
